import React, { useEffect, useState } from 'react';
import MensajeCargando from '../UI/MensajeCargando.js';
import MensajeError from '../UI/MensajeError.js';
import CeldaOrdenable from '../UI/CeldaOrdenable.js';
import * as Data from '../data/DataSeleccionesRivales.js';
import * as FuncionesOrdenamiento from '../funciones/FuncionesOrdenamiento.js';
import styles from './Enfrentamientos.module.css';

const getNombreRival = (rival) =>
  rival.paisRival?.nombre ||
  rival.clubRival?.nombre ||
  rival.equipoRival?.nombre ||
  rival.nombre ||
  '-';

const getIdRival = (rival) =>
  rival.paisRival?.id ?? rival.clubRival?.id ?? rival.equipoRival?.id ?? rival.id;

const getPaisRival = (rival) =>
  rival.clubRival?.pais?.nombre || rival.equipoRival?.pais?.nombre || null;

const getRivalObjeto = (rival, tipoRivalId) => {
  if (tipoRivalId === 'S') {
    return (
      rival.paisRival || (rival.id != null ? { id: rival.id, nombre: getNombreRival(rival) } : null)
    );
  }
  if (tipoRivalId === 'C') {
    return (
      rival.clubRival || (rival.id != null ? { id: rival.id, nombre: getNombreRival(rival) } : null)
    );
  }
  if (tipoRivalId === 'E') {
    return (
      rival.equipoRival ||
      (rival.id != null ? { id: rival.id, nombre: getNombreRival(rival) } : null)
    );
  }
  return rival.id != null ? { id: rival.id, nombre: getNombreRival(rival) } : null;
};

const TotalesRivales = (props) => {
  const idPais = props.idPais;
  const tipoRivalId = props.tipoRivalId;
  const categoria = props.categoria;
  const tipoInternacional = props.tipoInternacional;
  const searchTrigger = props.searchTrigger;
  const onRivalElegido = props.onRivalElegido;

  const [rivales, setRivales] = useState([]);
  const [isCargando, setIsCargando] = useState(false);
  const [errores, setErrores] = useState(null);
  const [ordenamientos, setOrdenamientos] = useState([
    { campo: FuncionesOrdenamiento.CamposOrdenamiento.RIVAL, ascendente: true },
  ]);

  useEffect(() => {
    if (!idPais || !tipoRivalId || searchTrigger === undefined) return;
    setIsCargando(true);
    setErrores(null);
    Data.GetTotalesRivales(idPais, tipoRivalId, categoria, tipoInternacional)
      .then((lista) => {
        setRivales(lista || []);
        setIsCargando(false);
      })
      .catch((err) => {
        setErrores([err.message || 'Error al cargar totales']);
        setIsCargando(false);
      });
  }, [idPais, tipoRivalId, categoria, tipoInternacional, searchTrigger]);

  // Función para calcular totales
  const calcularTotales = () => {
    if (!rivales || rivales.length === 0) {
      return {
        totalPartidos: 0,
        ganados: 0,
        empatados: 0,
        perdidos: 0,
        golesAFavor: 0,
        golesEnContra: 0,
      };
    }

    return {
      totalPartidos: rivales.reduce((sum, r) => sum + (r.totalPartidos || 0), 0),
      ganados: rivales.reduce((sum, r) => sum + (r.ganados || 0), 0),
      empatados: rivales.reduce((sum, r) => sum + (r.empatados || 0), 0),
      perdidos: rivales.reduce((sum, r) => sum + (r.perdidos || 0), 0),
      golesAFavor: rivales.reduce((sum, r) => sum + (r.golesAFavor || 0), 0),
      golesEnContra: rivales.reduce((sum, r) => sum + (r.golesEnContra || 0), 0),
    };
  };

  const totales = calcularTotales();

  if (isCargando) {
    return <MensajeCargando />;
  }

  return (
    <div className={styles.contenedor}>
      {errores && errores.length > 0 && <MensajeError errores={errores} />}

      {rivales && rivales.length > 0 && (
        <div className={styles.tablaContenedor}>
          <table className={styles.tabla}>
            <thead>
              <tr>
                <CeldaOrdenable
                  campo={FuncionesOrdenamiento.CamposOrdenamiento.RIVAL}
                  label="Rival"
                  ordenamientos={ordenamientos}
                  onChange={setOrdenamientos}
                  className={styles.headerRival}
                  title="Click para ordenar. Shift+Click para ordenamiento secundario"
                />
                {(tipoRivalId === 'C' || tipoRivalId === 'E') && (
                  <th className={styles.headerPais}>País</th>
                )}
                <CeldaOrdenable
                  campo={FuncionesOrdenamiento.CamposOrdenamiento.PARTIDOS}
                  label="PJ"
                  ordenamientos={ordenamientos}
                  onChange={setOrdenamientos}
                  className={styles.headerPartidos}
                  title="Partidos jugados. Click para ordenar, Shift+Click para secundario"
                />
                <CeldaOrdenable
                  campo={FuncionesOrdenamiento.CamposOrdenamiento.GANADOS}
                  label="PG"
                  ordenamientos={ordenamientos}
                  onChange={setOrdenamientos}
                  className={styles.headerGanados}
                  title="Partidos ganados. Click para ordenar, Shift+Click para secundario"
                />
                <CeldaOrdenable
                  campo={FuncionesOrdenamiento.CamposOrdenamiento.EMPATADOS}
                  label="PE"
                  ordenamientos={ordenamientos}
                  onChange={setOrdenamientos}
                  className={styles.headerEmpatados}
                  title="Partidos empatados. Click para ordenar, Shift+Click para secundario"
                />
                <CeldaOrdenable
                  campo={FuncionesOrdenamiento.CamposOrdenamiento.PERDIDOS}
                  label="PP"
                  ordenamientos={ordenamientos}
                  onChange={setOrdenamientos}
                  className={styles.headerPerdidos}
                  title="Partidos perdidos. Click para ordenar, Shift+Click para secundario"
                />
                <CeldaOrdenable
                  campo={FuncionesOrdenamiento.CamposOrdenamiento.GOLES_FAVOR}
                  label="GF"
                  ordenamientos={ordenamientos}
                  onChange={setOrdenamientos}
                  className={styles.headerGolesFavor}
                  title="Goles a favor. Click para ordenar, Shift+Click para secundario"
                />
                <CeldaOrdenable
                  campo={FuncionesOrdenamiento.CamposOrdenamiento.GOLES_CONTRA}
                  label="GC"
                  ordenamientos={ordenamientos}
                  onChange={setOrdenamientos}
                  className={styles.headerGolesContra}
                  title="Goles en contra. Click para ordenar, Shift+Click para secundario"
                />
                <CeldaOrdenable
                  campo={FuncionesOrdenamiento.CamposOrdenamiento.DIF}
                  label="Dif"
                  ordenamientos={ordenamientos}
                  onChange={setOrdenamientos}
                  className={styles.headerDif}
                  title="Diferencia de goles. Click para ordenar, Shift+Click para secundario"
                />
              </tr>
            </thead>
            <tbody>
              {FuncionesOrdenamiento.ordenarListaMultiNivel(
                rivales,
                ordenamientos,
                FuncionesOrdenamiento.configEnfrentamientos
              ).map((rival) => (
                <tr key={getIdRival(rival)}>
                  <td className={styles.colRival}>
                    <button
                      type="button"
                      className={styles.linkRival}
                      onClick={() => {
                        const rivalObjeto = getRivalObjeto(rival, tipoRivalId);
                        if (rivalObjeto && typeof onRivalElegido === 'function') {
                          onRivalElegido(rivalObjeto);
                        }
                      }}
                      title="Ver partidos contra este rival"
                    >
                      {getNombreRival(rival)}
                    </button>
                  </td>
                  {(tipoRivalId === 'C' || tipoRivalId === 'E') && (
                    <td className={styles.colPais}>{getPaisRival(rival) || '-'}</td>
                  )}
                  <td className={styles.colTotal}>{rival.totalPartidos || 0}</td>
                  <td className={styles.colPartidos}>{rival.ganados || 0}</td>
                  <td className={styles.colPartidos}>{rival.empatados || 0}</td>
                  <td className={styles.colPartidos}>{rival.perdidos || 0}</td>
                  <td className={styles.colGoles}>{rival.golesAFavor || 0}</td>
                  <td className={styles.colGoles}>{rival.golesEnContra || 0}</td>
                  <td className={styles.colDif}>
                    {(rival.golesAFavor || 0) - (rival.golesEnContra || 0)}
                  </td>
                </tr>
              ))}
              <tr className={styles.filaTotal}>
                <td className={styles.colRival}>
                  <strong>TOTALES</strong>
                </td>
                {(tipoRivalId === 'C' || tipoRivalId === 'E') && <td className={styles.colPais} />}
                <td className={styles.colTotal}>
                  <strong>{totales.totalPartidos}</strong>
                </td>
                <td className={styles.colPartidos}>
                  <strong>{totales.ganados}</strong>
                </td>
                <td className={styles.colPartidos}>
                  <strong>{totales.empatados}</strong>
                </td>
                <td className={styles.colPartidos}>
                  <strong>{totales.perdidos}</strong>
                </td>
                <td className={styles.colGoles}>
                  <strong>{totales.golesAFavor}</strong>
                </td>
                <td className={styles.colGoles}>
                  <strong>{totales.golesEnContra}</strong>
                </td>
                <td className={styles.colDif}>
                  <strong>{totales.golesAFavor - totales.golesEnContra}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {!isCargando && (!rivales || rivales.length === 0) && !errores && (
        <p className={styles.mensajeVacio}>No hay enfrentamientos registrados</p>
      )}
    </div>
  );
};

export default TotalesRivales;
